import { Box, Button, IconButton, Tooltip } from "@mui/material";
import React, { useContext } from "react";
import ApiPaginate from "../component/ApiPaginate";
import ApiEndpoints from "../network/ApiEndPoints";
import CachedIcon from "@mui/icons-material/Cached";
import { useState } from "react";
import { CustomStyles } from "../component/CustomStyle";
import { useNavigate } from "react-router-dom";
import { ddmmyy, dateToTime } from "../utils/DateUtils";

import UpdateScheme from "../modals/UpdateScheme";
import AddUtilityModel from "../modals/AddUtilityModel";
// import ClaimCollections from "../modals/ClaimCollections";
import AuthContext from "../store/AuthContext";
import ApiPaginateSearch from "../component/ApiPaginateSearch";
import FilterCard from "../modals/FilterCard";
import { get, postJsonData } from "../network/ApiController";
import { json2Csv, json2Excel } from "../utils/exportToExcel";
import ExcelUploadModal from "../modals/ExcelUploadModal";
import moment from "moment";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";
// import ClaimCollections2 from "../modals/ClaimCollections2";

import VerifiedIcon from "@mui/icons-material/Verified";
import AdminClaimCollections from "../modals/AdminClaimCollections";
import AdminClaimCollections2 from "../modals/AdminClaimCollections2";

let refresh;
let handleCloseModal;
function refreshFunc(setQueryParams) {
  setQueryParams("");
  if (refresh) refresh();
}
const AdminCollections2 = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState();
  const navigate = useNavigate();

  const [request, setRequest] = useState(false);
  const authCtx = useContext(AuthContext);
  const [noOfResponses, setNoOfResponses] = useState(0);
  const user = authCtx.user;

  //   const handleStatusCheck = (row) => {
  //     if (!row?.order_id) {
  //       apiErrorToast("Order ID not available");
  //       return;
  //     }

  //     postJsonData(
  //       ApiEndpoints.STATUS_CHECK_PG,
  //       { order_id: row.order_id },
  //       setRequest,
  //       (res) => {
  //         okSuccessToast(res?.message || "Status Updated Successfully");
  //         if (refresh) refresh();
  //       },
  //       (err) => {
  //         apiErrorToast(err);
  //       },
  //     );
  //   };

  const columns = [
    {
      name: "Date",
      selector: (row) => (
        <div className="mb-1">
          {/* CREATED AT */}
          <Tooltip
            title={
              <>
                <strong>Created Date:</strong> {ddmmyy(row.created_at)}
                <br />
                <strong>Created Time:</strong> {dateToTime(row.created_at)}
              </>
            }
            arrow
          >
            <div style={{ cursor: "pointer" }}>{ddmmyy(row.created_at)}</div>
          </Tooltip>

          <hr style={{ margin: "3px 0" }} />

          {/* UPDATED AT */}
          <Tooltip
            title={
              <>
                <strong>Updated Date:</strong> {ddmmyy(row.updated_at)}
                <br />
                <strong>Updated Time:</strong> {dateToTime(row.updated_at)}
              </>
            }
            arrow
          >
            <div style={{ cursor: "pointer" }}>{ddmmyy(row.updated_at)}</div>
          </Tooltip>
        </div>
      ),
      width: "80px",
    },

    {
      name: "ID",
      selector: (row) => <div className="blue-highlight-txt">{row.id}</div>,
      width: "50px",
    },
    {
      name: "Name",
      selector: (row) => row.name || "NA",
    },
    {
      name: "Number",
      selector: (row) => row.number || "NA",
    },
    {
      name: "C Number",
      selector: (row) => row.c_number || "N/A",
    },

    {
      name: "RRN",
      selector: (row) => (
        <Tooltip title={row.rrn || "-"}>
          <span>{row.rrn || "-"}</span>
        </Tooltip>
      ),
    },
    {
      name: "OrderId",
      selector: (row) => (
        <Tooltip title={row.order_id || "-"}>
          <span>{row.order_id || "-"}</span>
        </Tooltip>
      ),
    },
    {
      name: "TxnId",
      selector: (row) => (
        <Tooltip title={row.txn_id || "-"}>
          <span>{row.txn_id || "-"}</span>
        </Tooltip>
      ),
    },

    // {
    //   name: "payeeAddress",
    //   selector: (row) => row.payeeAddress,
    //    width:"200px"
    // },
    {
      name: "amount",
      selector: (row) => row.amount || 0,
    },
    // {
    //   name: "Routes",
    //   selector: (row) => row.route==="UPI"?"Pipe 2":"Pipe 1",
    // },

    {
      name: "remark",
      selector: (row) => row.remark || "N/A",
    },
    {
      name: "status",
      selector: (row) => row.status || "N/A",
    },

    (user.role === "Ret" || user.role === "Dd") && {
      name: "action",
      selector: (row) => <AdminClaimCollections row={row} refresh={refresh} />,
    },
    {
      name: "actions",
      selector: (row) => (
        <Box sx={{ display: "flex" }}>
          {<AdminClaimCollections2 row={row} refresh={refresh} />}
          {/* {row.status==="Pending"&&<UpiCheckStatusModal row={row}/>} */}

          {/* {row.status === "PENDING" && (
            <Tooltip title="Check PG Status">
              <IconButton
                size="small"
                color="primary"
                disabled={request}
                onClick={() => handleStatusCheck(row)}
              >
                <VerifiedIcon />
              </IconButton>
            </Tooltip>
          )} */}
        </Box>
      ),
    },
  ];

  const getExcel = () => {
    get(
      ApiEndpoints.GET_COLLECTIONS2,
      `${
        query
          ? query + "&page=1&paginate=10&platform=WEB&export=1"
          : "page=1&paginate=10&platform=WEB&export=1"
      }`,
      setRequest,
      (res) => {
        const apiData = res.data.data;
        const newApiData = apiData.map((item) => {
          const created_at = moment(item.created_at).utc().format("DD-MM-YYYY");
          const updated_at = moment(item.updated_at).utc().format("DD-MM-YYYY");
          return { ...item, created_at, updated_at };
        });
        json2Excel(
          `collections ${moment(new Date().toJSON()).format(
            "Do MMM YYYY",
          )} | ${moment(new Date().toJSON()).format("hh:mm a")}`,
          JSON.parse(JSON.stringify(newApiData && newApiData)),
        );
        handleCloseModal();
      },
      (err) => {
        apiErrorToast(err);
      },
    );
  };

  const getCsv = () => {
    get(
      ApiEndpoints.GET_COLLECTIONS2,
      `${
        query
          ? query + "&page=1&paginate=10&platform=WEB&export=1"
          : "page=1&paginate=10&platform=WEB&export=1"
      }`,
      setRequest,
      (res) => {
        const apiData = res.data.data;
        const newApiData = apiData.map((item) => {
          const created_at = moment(item.created_at).format("DD-MM-YYYY");
          const time_updated_at = moment(item.updated_at).format("LTS");
          return { ...item, created_at, time_updated_at };
        });
        json2Csv(
          `collections ${moment(new Date().toJSON()).format(
            "Do MMM YYYY",
          )} | ${moment(new Date().toJSON()).format("hh:mm a")}`,
          JSON.parse(JSON.stringify(newApiData && newApiData)),
        );
        handleCloseModal();
      },
      (err) => {
        apiErrorToast(err);
      },
    );
  };
  const roles = ["Admin", "Ret"];
  return (
    <Box>
      {roles.includes(user?.role) && (
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Tooltip title="refresh">
            <IconButton
              aria-label="refresh"
              // color="success"
              sx={{
                color: "#0F52BA",
              }}
              onClick={() => {
                refreshFunc(setQuery);
              }}
            >
              <CachedIcon className="refresh-purple" />
            </IconButton>
          </Tooltip>
        </Box>
      )}
      <div>
        <ApiPaginateSearch
          apiEnd={ApiEndpoints.GET_COLLECTIONS2}
          columns={columns}
          apiData={apiData}
          setQuery={setQuery}
          query={query}
          tableStyle={CustomStyles}
          setApiData={setApiData}
          ExpandedComponent=""
          queryParam={query ? query : ""}
          returnRefetch={(ref) => {
            refresh = ref;
          }}
          responses={(val) => {
            setNoOfResponses(val);
          }}
          isFilterAllowed={user.role === "Admin"}
          filterComponent={
            <FilterCard
              setQuery={setQuery}
              ifUsernameFilter
              ifdateFilter
              ifStatusFilter
              isTransaction={true}
              iscollections={true}
              setApiData={setApiData}
              apiData={apiData}
              query={query}
              actionButtons={
                <>
                  <Box sx={{ display: "flex" }}>
                    {user?.role === "Ret" && (
                      <ExcelUploadModal
                        twobuttons="Download Csv"
                        btn
                        request={request}
                        getExcel={getExcel}
                        getCsv={getCsv}
                        noOfResponses={noOfResponses}
                        handleCloseCB={(closeModal) => {
                          handleCloseModal = closeModal;
                        }}
                      />
                    )}

                    <Tooltip title="refresh">
                      <IconButton
                        className=""
                        aria-label="refresh"
                        color="success"
                        onClick={() => {
                          refreshFunc(setQuery);
                        }}
                      >
                        <CachedIcon className="refresh-purple" />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </>
              }
            />
          }
          paginateServer={true}
          paginate={true}
        />
      </div>
    </Box>
  );
};

export default AdminCollections2;
